<template>
	<div>
	<MasterHeader
		v-bind:classHeader="classHeader"
		v-bind:classGrid="classGrid"/>
		<section>
			<div class="wp1200">
				<div class="tab">
					<button
						class="tablinks"
						v-bind:class="{ active: isRegisterActive }"
						v-on:click.prevent="RegisterButtonClick()"
					>{{ $t("login.register") }}</button>
					<button
						class="tablinks"
						v-bind:class="{ active: isLoginActive }"
						v-on:click.prevent="LoginButtonClick()"
					>{{ $t("login.login") }}</button>
				</div>
				<div v-show="isLoginActive">
					<Login></Login>
				</div>
				<div v-show="isRegisterActive" >
					<Register></Register>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Register from "./Login/Register";
import Login from "./Login/Login";
import MasterHeader from "./partials/MasterHeader";
export default {
	data() {
		return {
			isRegisterActive: true,
			isLoginActive: false,
			classHeader:"registration",
			classGrid:"wp1200"
		};
	},
	components: {
		Register,
		Login,
		MasterHeader
	},
	mounted() {
		this.setActiveTabFromQuery();
	},

	methods: {
		setActiveTabFromQuery() {
			const activeTab = this.$route.query.activeTab;
			if (activeTab === 'login') {
				this.isLoginActive = true;
				this.isRegisterActive = false;
			} else if (activeTab === 'register') {
				this.isRegisterActive = true;
				this.isLoginActive = false;
			}
		},
		RegisterButtonClick() {
			this.isRegisterActive = true;
			this.isLoginActive = false;
		},
		LoginButtonClick() {
			this.isRegisterActive = false;
			this.isLoginActive = true;
		},
	},
};
</script>

<style>
</style>